/**
 * DragPreview.tsx - DragPreview - Visual feedback during drag
 * 
 * CHANGE HISTORY:
 * - 251021_0421 [7529d5e] danielbeer: feat: migrate all packages to TypeScript structure
 */
import React from 'react';
import './DragPreview.css';

export const DragPreview = ({ item, count = 1, type = 'item' }) => {
  return (
    <div className="drag-preview">
      <div className="drag-preview-content">
        {item.icon && <span className="drag-preview-icon">{item.icon}</span>}
        <span className="drag-preview-text">{item.name || item.title || 'Item'}</span>
        {count > 1 && (
          <span className="drag-preview-count">{count}</span>
        )}
      </div>
      <div className="drag-preview-type">{type}</div>
    </div>
  );
};

export const DropZoneIndicator = ({ active, accepts, position }) => {
  return (
    <div className={`drop-zone-indicator ${active ? 'active' : ''}`}>
      <div className="drop-zone-content">
        <span className="drop-zone-icon">📥</span>
        <span className="drop-zone-text">
          {active ? 'Drop here' : `Drop ${accepts.join(', ')}`}
        </span>
      </div>
    </div>
  );
};

export const FileExportIndicator = ({ fileName, progress }) => {
  return (
    <div className="file-export-indicator">
      <div className="file-export-icon">📄</div>
      <div className="file-export-info">
        <div className="file-export-name">{fileName}</div>
        {progress !== undefined && (
          <div className="file-export-progress">
            <div 
              className="file-export-progress-bar"
              style={{ width: `${progress}%` }}
            />
            <span className="file-export-progress-text">{progress}%</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default DragPreview;
